import $ from 'jquery';

const elements = document.querySelectorAll('.is-animation');

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.bottom > 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

function animateValue(from, to, element) {
  const duration = 1000;
  const range = to - from;
  const start = Date.now();
  const step = () => {
    const now = Date.now();
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const value = from + progress * range;
    if (Number.isInteger(to)) {
      if (to >= 1000) {
        const haha = Math.floor(value);
        element.textContent = haha.toLocaleString("en-IN");
      } else {
        element.textContent = Math.floor(value);
      }
    } else {
      element.textContent = value.toFixed(1);
    }
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}
function handleScroll() {
  elements.forEach(element => {
    if (isElementInViewport(element)) {
      if (!element.hasAttribute('data-animated') && element.hasAttribute('data-from')) {
        const from = parseFloat(element.dataset.from, 10);
        const to = parseFloat(element.dataset.to, 10);
        animateValue(from, to, element);
        element.setAttribute('data-animated', 'true');
      } else {
        element.classList.add("is-show");
      }
    }
    // else {
    //   element.removeAttribute('data-animated');
    //   element.classList.remove("is-show");
    // }
  });
}
window.addEventListener('scroll', handleScroll);

$('.js-animationText .js-animationText-wrap').html(function (index, html) {
  return html.replace(/\S/g, '<span>$&</span>');
});

$(window).on('load', function () {

  let $count1 = 1.6;

  $('.js-animationText .js-animationText-wrap > span').each(function () {
    $(this).css({
      'transition-delay': $count1 + 's',
    });
    $count1 = $count1 + 0.1;
  });
});

$('.js-animationText1 .js-animationText1-wrap').html(function (index, html) {
  return html.replace(/\S/g, '<span>$&</span>');
});

$(window).on('load', function () {

  let $count1 = 0.1;

  $('.js-animationText1 .js-animationText1-wrap > span').each(function () {
    $(this).css({
      'transition-delay': $count1 + 's',
    });
    $count1 = $count1 + 0.1;
  });
});

$('.js-animationText2 .js-animationText2-wrap').html(function (index, html) {
  return html.replace(/\S/g, '<span>$&</span>');
});

$(window).on('load', function () {

  let $count1 = 0.1;

  $('.js-animationText2 .js-animationText2-wrap > span').each(function () {
    $(this).css({
      'transition-delay': $count1 + 's',
    });
    $count1 = $count1 + 0.1;
  });
});

$('.js-animationText3 .js-animationText3-wrap').html(function (index, html) {
  return html.replace(/\S/g, '<span>$&</span>');
});

$(window).on('load', function () {

  let $count1 = 0.1;

  $('.js-animationText3 .js-animationText3-wrap > span').each(function () {
    $(this).css({
      'transition-delay': $count1 + 's',
    });
    $count1 = $count1 + 0.1;
  });
});

$('.js-animationText4 .js-animationText4-wrap').html(function (index, html) {
  return html.replace(/\S/g, '<span>$&</span>');
});

$(window).on('load', function () {

  let $count1 = 0.1;

  $('.js-animationText4 .js-animationText4-wrap > span').each(function () {
    $(this).css({
      'transition-delay': $count1 + 's',
    });
    $count1 = $count1 + 0.1;
  });
});